<div class="site-budget-supporting-documents">
  @let mergedFiles = mergedFiles$ | async;
  @let reasonsToDisable = siteWorkflow.updateSiteCostTooltips();

  <p class="mb-1 text-base font-bold">Supporting Documents</p>

  <div
    class="flex h-full flex-col rounded-lg border border-aux-gray-dark p-4"
    [class.justify-center]="!mergedFiles?.length"
    [class.items-center]="!mergedFiles?.length"
    [class.justify-between]="!!mergedFiles?.length"
    [class.bg-aux-gray-dark-2]="siteWorkflow.disabledUpdateSiteCostUI()"
    auxSkeletonLoader
    [loading]="isProcessing()"
  >
    @if (mergedFiles?.length) {
      <div class="flex max-h-[200px] flex-col space-y-4 overflow-y-auto">
        @for (file of mergedFiles; track file.id) {
          <div class="flex justify-between">
            <p class="text-aux-gray-darkest">{{ file.fileName }}</p>

            <div class="flex items-center space-x-2">
              <aux-icon
                name="Download"
                class="cursor-pointer text-aux-blue"
                [class.opacity-50]="
                  file.source === 'siteBudget'
                    ? fetchSiteBudgetDocumentsQuery.isFetching()
                    : fetchSiteDocumentsQuery.isFetching()
                "
                [class.pointer-events-none]="
                  file.source === 'siteBudget'
                    ? fetchSiteBudgetDocumentsQuery.isFetching()
                    : fetchSiteDocumentsQuery.isFetching()
                "
                (click)="downloadFile(file)"
              />
              <aux-icon
                name="Trash"
                class="cursor-pointer text-aux-error"
                [class.opacity-50]="isProcessing() || siteWorkflow.disabledUpdateSiteCostUI()"
                [class.pointer-events-none]="
                  isProcessing() || siteWorkflow.disabledUpdateSiteCostUI()
                "
                (click)="deleteFile(file)"
              />
            </div>
          </div>
        }
      </div>
    }
    <div class="flex justify-end" [class.mt-4]="!!mergedFiles?.length">
      @if (selectedSiteBudgetVersion()) {
        @if (isInitialSiteBudget()) {
          <aux-file-manager
            class="border-none"
            #siteManager
            [path]="sitePath()"
            [eager]="false"
            [metadata]="siteDocumentsMetadata()"
            (fileManagerReady)="siteManagerReady($event)"
          >
            <div></div>
          </aux-file-manager>
        }
        <aux-file-manager
          class="border-none"
          #siteBudgetManager
          [path]="siteBudgetPath()"
          [eager]="false"
          [metadata]="siteBudgetDocumentsMetadata()"
          (fileManagerReady)="siteBudgetManagerReady($event)"
          (onFilesAdded)="onFilesAdded()"
          [disabled]="siteWorkflow.disabledUpdateSiteCostUI()"
        >
          @if (!mergedFiles?.length) {
            <p>
              Drag and drop documents here, or
              <span
                class="btn-ds px-0 text-base text-aux-blue-link underline group-hover:text-aux-blue group-active:text-aux-blue-dark"
              >
                browse
              </span>
            </p>
          } @else {
            <div
              class="flex items-center space-x-2 text-aux-blue"
              [class.opacity-50]="isProcessing()"
            >
              <aux-icon name="Upload" [size]="14" />
              <span class="text-sm">Upload New Document</span>
            </div>
          }
        </aux-file-manager>
      }
    </div>
  </div>

  <ng-template #tooltipTemplate>
    <aux-errors-tooltip [errors]="reasonsToDisable" />
  </ng-template>
</div>
